import React from "react";
import Navbar from '../../components/Navbar'

function CancellationAndRefundPolicy() {
    return (
        <>
            <Navbar />
            <div className="container">
                <div className="justify-content-sm-center pt-5">
                    <h2 style={{ textAlign: "center", padding: "13%" }}>
                        <u>CANCELLATION AND REFUND POLICY</u>
                        <br />
                        <h4 className="text-center">(Applicable for countries outside India)</h4>
                    </h2>
                    <h5>Last Updated: Oct 24, 2025</h5>
                    <br />
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <p style={{ color: "black" }}>
                            As we SassyMonks Pvt Ltd are providing FleetOrder as a platform for
                            managing restaurants, you can subscribe to our FleetOrder Platform
                            as per available plans. You are required to pay us digitally.
                        </p>

                        <h4>Subscription Cancellation &amp; Refund</h4>
                        <ul style={{ color: "black" }}>
                            <li>
                                You can cancel the annual FleetOrder subscription at any time. We
                                will charge for the running month and refund you the remaining
                                prorated amount.
                                <br />
                                For example: If you cancel any time before the next month starts,
                                we will refund the amount from the start of next month to the end
                                of the subscription. If you cancel on the 1st day of the month,
                                the current month will be charged and the remaining amount will be
                                refunded.
                            </li>
                            <li>
                                There is no refund policy for customers who reside in India.
                            </li>
                        </ul>
                    </div>

                    <div className="col-md-12">
                        <h4>Revisions</h4>
                        <ul style={{ color: "black" }}>
                            <li>
                                We may, in our discretion, change the Terms of Service as well as
                                this Cancellation &amp; Refund Policy, or any aspect of FleetOrder
                                Subscription, without notice to you. If any change to these terms
                                is found invalid, void, or for any reason unenforceable, that
                                change is severable and does not affect the validity and
                                enforceability of any remaining changes or conditions. Your
                                continued subscription after we change these terms constitutes
                                your acceptance of the changes. If you do not agree to any
                                changes, you must cancel your subscription.
                            </li>
                        </ul>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </>
    )
}

export default CancellationAndRefundPolicy